// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3BpRM","boxTitle":"Qualiphy_boxTitle__3rKVR","box":"Qualiphy_box__3Qv-x","toggleWrap":"Qualiphy_toggleWrap__1BUnQ"};